import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts";
const fetchWalletSummary = async (pubId, userId) => {
    const { data } = await API.get(`/api/v1/rbzo/loyalty/${pubId}/wallet-summary`, { params: { userId } });
    return data === null || data === void 0 ? void 0 : data.data;
};
export const useLoyaltyWalletSummary = (pubId) => {
    const { customerData } = useCustomer();
    const userId = customerData === null || customerData === void 0 ? void 0 : customerData.uuid;
    return useQuery(["loyaltyWalletSummary", pubId, userId], () => fetchWalletSummary(pubId, userId), {
        enabled: !!pubId && !!userId,
    });
};
